import { Hero } from "@/components/home/Hero";
import { SignatureIndex } from "@/components/home/SignatureIndex";
import { SeoIntro } from "@/components/home/SeoIntro";
import { TrustStrip } from "@/components/site/Trust";
import { DiagnosticBanner } from "@/components/home/DiagnosticBanner";
import { SubHomeBanner } from "@/components/subscription/SubPromo";
import { FlashHero } from "@/components/site/FlashSale";
import { FormationHomeBlock } from "@/components/formation/FormationHome";
import { ShopReviewsHighlight } from "@/components/site/ShopReviews";
import { LuminaLaunch } from "@/components/lumina/LuminaLaunch";
import { useSeo, ORGANIZATION, SITE_URL } from "@/lib/seo";

const LD = {
  "@context": "https://schema.org",
  "@graph": [
    ORGANIZATION,
    { "@type": "WebSite", "@id": `${SITE_URL}/#website`, url: `${SITE_URL}/`, name: "Ozentya", alternateName: "Ozentya — soins cheveux afro", inLanguage: "fr-FR", publisher: { "@id": `${SITE_URL}/#organization` } },
    { "@type": "WebPage", "@id": `${SITE_URL}/#webpage`, url: `${SITE_URL}/`, name: "Ozentya — Soins cheveux afro, crépus et naturels", isPartOf: { "@id": `${SITE_URL}/#website` }, about: { "@id": `${SITE_URL}/#organization` }, inLanguage: "fr-FR" },
  ],
};

export default function Home() {
  useSeo({
    title: "Ozentya : chute de cheveux et alopécie femme afro, depuis 2011",
    description: "Depuis 2011, Ozentya est la marque spécialiste de la chute de cheveux et de l'alopécie chez la femme afro : soins Extrême Repouss, cures, cheveux crépus, locks, barbe. Livraison gratuite en Point Relais.",
    path: "/", jsonLd: LD,
  });
  return (
    <main data-testid="home-page">
      {/* Accueil resserré : promesse → réassurance → nouveauté → best-sellers → avis → un seul bloc abonnement (Duo, Famille) → aide au choix. */}
      <Hero />
      <TrustStrip />
      <FormationHomeBlock />
      <FlashHero />
      <LuminaLaunch />
      <SignatureIndex />
      <ShopReviewsHighlight />
      <SubHomeBanner />
      <DiagnosticBanner />
      <SeoIntro />
    </main>
  );
}
